import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1e363c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = ["name", "value", "checked", "onChange"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]

import { withDefaults } from 'vue'

import AppImage from '@/components/AppImage/AppImage.vue'

interface Props {
  currentValue: string | number | null
  groupName: string
  groupColor?: string
  list: {
    code: string | number | null
    name: string
    rubyName?: string
    icon?: string
  }[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioGroup',
  props: {
    currentValue: null,
    groupName: null,
    groupColor: { default: 'cyan' },
    list: null
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as { currentValue: string | number | null, groupName: string, groupColor: string, list: {
    code: string | number | null
    name: string
    rubyName?: string
    icon?: string
  }[] }

/**
 * RadioGroup.
 *
 * ラジオボタンのグループ
 */





const onChange = (item: Props['list'][0], event: Event) => {
  const target = event.currentTarget

  if (!(target instanceof HTMLInputElement)) return

  emit('change', item, event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
      return (_openBlock(), _createElementBlock("label", {
        key: item.code
      }, [
        _createElementVNode("input", {
          type: "radio",
          name: __props.groupName,
          value: item.code,
          checked: item.code === __props.currentValue,
          class: "input",
          onChange: ($event: any) => (onChange(item, $event))
        }, null, 40, _hoisted_2),
        _createElementVNode("span", {
          class: _normalizeClass(["radio", [__props.groupColor, { checked: item.code === __props.currentValue }]])
        }, [
          (item.icon)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createVNode(AppImage, {
                  src: item.icon,
                  alt: item.name,
                  width: "20",
                  height: "20"
                }, null, 8, ["src", "alt"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            innerHTML: item.rubyName || item.name
          }, null, 8, _hoisted_4)
        ], 2)
      ]))
    }), 128))
  ]))
}
}

})